import { Tab } from '@headlessui/react';
import React, { useEffect, useState } from 'react';
import { Assets } from './asset';
import minimizeIcon from "../../../../../assets/svg/minimizeIcon.svg";
import { DataPanel } from './DataPanel';
import { Validation } from './Validation';
import { ReactComponent as AssetIcon } from "../../../../../assets/svg/solobuilder/asset.svg";
import { ReactComponent as TreeViewIcon } from "../../../../../assets/svg/solobuilder/treeview.svg";
import { ReactComponent as DataIcon } from "../../../../../assets/svg/solobuilder/dataicon.svg";
import { ReactComponent as ValidationIcon } from "../../../../../assets/svg/solobuilder/validationicon.svg";
import { TreeView } from './treeview';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../stateManager/store';
import { getComponents } from '../helpers';
import { setStepIndex } from '../../../../../stateManager/store/onboarding/action';


type FormPropsLeftNavProps = {
    isCheckedIn: boolean;
};

const FormPropsLeftNav: React.FC<FormPropsLeftNavProps> = ({ isCheckedIn }) => {
    const [activeTab, setActiveTab] = useState<number>(0)
    const { isAssetInstanceSelected, selectedElementId } = useSelector((state: AppState) => {
        const formJson = state.formJson
        return {
            isAssetInstanceSelected: formJson.isAssetInstanceSelected,
            assetEditModeEnabled: formJson.assetEditMode.isEnabled,
            selectedElementId: formJson.selectedElementId,
            ClickEvent: formJson.ClickEvent
        }
    })
    const {guideVisible, info} = useSelector((state:AppState) => state.onboarding);
    const dispatch = useDispatch();

    useEffect(()=>{
        if (activeTab === 2 && guideVisible) {
            dispatch(setStepIndex(info.stepIndex + 1));
        }
    },[activeTab])

    const { components } = getComponents()
    const component = components[selectedElementId]
    const validationVisibility = component && component.properties && component?.properties.validation;
    const dataVisibility = component && component?.properties && component?.properties?.data;

    return (
        <div className='w-full h-full'>
            <Tab.Group selectedIndex={activeTab} onChange={setActiveTab}>
                <Tab.List style={{ background: "rgba(34, 57, 121, 0.06)", height: "50px", alignItems: "center" }} className="flex justify-between p-6 h-18 border border-gray-100">
                    <Tab title="Layers" className={`p-2 focus:outline-none ${!isCheckedIn ? "cursor-not-allowed":""}`}>
                        <TreeViewIcon height={17} width={17}  style={{ color: activeTab === 0 ? '#F1722E' : '#505F7B' }} />
                    </Tab>
                    <Tab title="Validation" disabled={!validationVisibility || !isCheckedIn} className={`p-2 focus:outline-none ${(!isCheckedIn || !validationVisibility) ? "cursor-not-allowed":""}`}>
                        <ValidationIcon height={15} width={19} style={{ color: activeTab === 1 ? '#F1722E' : '#505F7B' }} />
                    </Tab>
                    <Tab disabled={!dataVisibility  || !isCheckedIn} title="Data" className={`p-2 focus:outline-none tour_data_panel ${(!isCheckedIn || !dataVisibility) ? "cursor-not-allowed":""}`}>
                        <DataIcon height={15} width={14}  style={{ color: activeTab === 2 ? '#F1722E' : '#505F7B' }} />
                    </Tab>
                    <Tab title="Assets" className={`p-2 focus:outline-none ${!isCheckedIn ? "cursor-not-allowed":""}`} >
                        <AssetIcon height={15} width={15} style={{ color: activeTab === 3 ? '#F1722E' : '#505F7B' }} />
                    </Tab>
                </Tab.List>
                <Tab.Panels
                    style={{ height: "calc(100% - 50px)", backgroundColor: "#FCFCFC" }}
                >
                    <Tab.Panel >
                        <TreeView isCheckedIn={isCheckedIn} />
                    </Tab.Panel>
                    <Tab.Panel>
                        {!isAssetInstanceSelected && <Validation isCheckedIn={isCheckedIn} />}
                    </Tab.Panel>
                    <Tab.Panel>
                        {!isAssetInstanceSelected && <DataPanel isCheckedIn={isCheckedIn} />}
                    </Tab.Panel>
                    <Tab.Panel>
                        <Assets />
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};

export default FormPropsLeftNav;
